import { render, staticRenderFns } from "./ChartTabs.vue?vue&type=template&id=324516be&"
import script from "./ChartTabs.vue?vue&type=script&lang=js&"
export * from "./ChartTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports